const cardTypes : {[key:string] : string} = {
    NORMAL:"NORMAL",
    SPECIAL:"SPECIAL",
    WILD:"WILD",
    WILD_FOUR:"WILD_FOUR",
 }
 export default cardTypes